import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AttendanceModal from "./AttendanceModal";
import {
  getUsers,
  deleteUser,
  resourcesAttendances,
  activeRoutes,
} from "../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../helpers/alerts/alertHelper";
import { getPolicyUser, getStorageUser } from "../../helpers/api_helper";
import { Container, ButtonGroup, Button, DropdownItem } from "reactstrap";
import { getStorageCompany } from "../../helpers/api_helper";
import Select from "react-select";
import ButtonHelper from "../../helpers/ButtonHelper";
import PreviewPDF from "../../helpers/previewPDF";

const Attendance = () => {
  const date = new Date();
  const policy = getPolicyUser();
  const authUser = getStorageUser();
  const company = getStorageCompany();
  const [pending, setPending] = useState(false);
  const [modalPdf, setModalPdf] = useState({ show: false, update: false });
  const [datesDays, setDatesDays] = useState([]);
  const [attendanceModal, setAttendanceModal] = useState({
    show: false,
    id: null,
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [yearSelect, setYearSelect] = useState({
    value: date.getFullYear(),
    label: date.getFullYear(),
  });

  const [items, setItems] = useState([]);
  const [weeks, setWeeks] = useState([]);
  const [years, setYears] = useState([]);
  const numeroDeSemana = (fecha) => {
    const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24,
      DIAS_QUE_TIENE_UNA_SEMANA = 7,
      JUEVES = 4;
    fecha = new Date(
      Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
    );
    let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
    if (diaDeLaSemana === 0) {
      diaDeLaSemana = 7;
    }
    fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);
    const inicioDelAño = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));
    const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAño;
    return Math.ceil(
      (diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS + 1) /
        DIAS_QUE_TIENE_UNA_SEMANA
    );
  };
  const [weekSelect, setWeekSelect] = useState({
    value: numeroDeSemana(new Date()),
    label: `Semana ${numeroDeSemana(new Date())}`,
  });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "name",
    order: "asc",
    companySession: authUser.company_id,
    year: yearSelect.value,
    week: numeroDeSemana(new Date()),
  });

  useEffect(() => {
    const getAttendances = async () => {
      let params = { params: filters };
      setPending(true);
      const response = await resourcesAttendances("get", params);
      setItems(response.data.data);
      setYears(response.arrayDates);
      setDatesDays(response.days);
      setWeeks(response.initWeeks.weeks);
      setDataPag({
        current_page: response.data.current_page,
        from: response.data.from,
        last_page: response.data.last_page,
        links: response.data.links,
        path: response.data.path,
        per_page: response.data.per_page,
        to: response.data.to,
        total: response.data.total,
      });
      setWeekSelect(response.week);
      setPending(false);
    };
    getAttendances();
  }, [filters]);

  const columns = Columns(
    attendanceModal,
    setAttendanceModal,
    setFilters,
    filters,
    datesDays
  );

  const getReports = async (type, day) => {
    let config = {
      params: { ...filters, day },
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    const exportSalidas = await resourcesAttendances("get", config);
    if (type == 1) {
      const url = URL.createObjectURL(new Blob([exportSalidas]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Asistencias.xlsx");
      document.body.appendChild(link);
      link.click();
    } else {
      let nombre = "Archivo";
      var reader = new FileReader();
      reader.readAsDataURL(exportSalidas);
      reader.fileName = nombre[1] || nombre[0];
      reader.onloadend = function (name) {
        name = nombre[0];
        var base64data = reader.result;
        setModalPdf({ show: true, update: false, url: base64data });
      };
    }
  };

  document.title = "Asistencia | Sistema de Logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Asistencia"
              filterInp={false}
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="">
                <div className="mb-3">
                  <ButtonHelper
                    title="Exportar Excel"
                    addButon={false}
                    reportButons={true}
                    actionReportButon={getReports}
                    pdfButton={false}
                    childrenExport={
                      <>
                        <DropdownItem to="#" onClick={() => getReports(1, 0)}>
                          <i className="fa fa-file-pdf"></i> Excel Domingo
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(1, 1)}>
                          <i className="fa fa-file-excel"></i> Excel Lunes
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(1, 2)}>
                          <i className="fa fa-file-excel"></i> Excel Martes
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(1, 3)}>
                          <i className="fa fa-file-excel"></i> Excel Miércoles
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(1, 4)}>
                          <i className="fa fa-file-excel"></i> Excel Jueves
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(1, 5)}>
                          <i className="fa fa-file-excel"></i> Excel Viernes
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(1, 6)}>
                          <i className="fa fa-file-excel"></i> Excel Sabado
                        </DropdownItem>
                        <DropdownItem to="#" onClick={() => getReports(2)}>
                          <i className="fa fa-file-pdf"></i> Exportar PDF
                        </DropdownItem>
                      </>
                    }
                  >
                    <ButtonHelper
                      title="Exportar PDF"
                      addButon={false}
                      reportButons={true}
                      actionReportButon={getReports}
                      excelButton={false}
                      childrenExport={
                        <>
                          <DropdownItem to="#" onClick={() => getReports(2, 0)}>
                            <i className="fa fa-file-pdf"></i> PDF Domingo
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => getReports(2, 1)}>
                            <i className="fa fa-file-pdf"></i> PDF Lunes
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => getReports(2, 2)}>
                            <i className="fa fa-file-pdf"></i> PDF Martes
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => getReports(2, 3)}>
                            <i className="fa fa-file-pdf"></i> PDF Miércoles
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => getReports(2, 4)}>
                            <i className="fa fa-file-pdf"></i> PDF Jueves
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => getReports(2, 5)}>
                            <i className="fa fa-file-pdf"></i> PDF Viernes
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => getReports(2, 6)}>
                            <i className="fa fa-file-pdf"></i> PDF Sabado
                          </DropdownItem>
                        </>
                      }
                    />
                    {/* <Button
                          size="sm"
                          className="float-end me-2"
                          onClick={() => getReports(2)}
                        >
                          <i className="fa fa-file-pdf"></i> Exportar PDF
                        </Button> */}
                  </ButtonHelper>
                </div>
              </div>
              <div className="col-sm-3">
                <label className="form-label">Año:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  defaultValue={yearSelect}
                  isSearchable={false}
                  name="week"
                  placeholder="Año"
                  options={years}
                  onChange={(e) => [
                    setYearSelect(e),
                    setFilters({ ...filters, year: e.value }),
                    setWeeks(e.weeks),
                    setWeekSelect(e.weeks[0]),
                  ]}
                />
              </div>
              <div className="col-sm-3">
                <label className="form-label">Semana:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  defaultValue={weekSelect}
                  isSearchable={false}
                  name="week"
                  placeholder="Semanas del año"
                  options={weeks}
                  onChange={(e) => [
                    setWeekSelect(e),
                    setFilters({ ...filters, week: e.value }),
                  ]}
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {attendanceModal.show && (
          <AttendanceModal
            modal={attendanceModal}
            setModal={setAttendanceModal}
            items={items}
            setItems={setItems}
            authUser={authUser}
            filters={filters}
            setFilters={setFilters}
          />
        )}
        {modalPdf.show && (
          <PreviewPDF modalPdf={modalPdf} setModalPdf={setModalPdf} />
        )}
      </div>
    </React.Fragment>
  );
};

export default Attendance;
